import { useRef } from "react";
import { Link } from "react-router-dom";
import { mediaUrl } from "@/lib/api";

export default function ProjectCard({ project, className = "", aspect = "aspect-[16/10]" }) {
  const videoRef = useRef(null);
  const cover = project.cover_media || {};
  const isVideo = cover.type === "video";

  return (
    <Link
      to={`/work/${project.slug}`}
      data-testid={`project-card-${project.slug}`}
      className={`group block ${className}`}
    >
      <div
        className={`relative overflow-hidden rounded-2xl border border-white/10 bg-white/[0.02] ${aspect}`}
        onMouseEnter={() => isVideo && videoRef.current?.play().catch(() => {})}
        onMouseLeave={() => videoRef.current?.pause()}
      >
        {isVideo ? (
          <video
            ref={videoRef}
            src={mediaUrl(cover.url) + "#t=0.1"}
            muted
            loop
            playsInline
            preload="metadata"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
        ) : (
          <img
            src={mediaUrl(cover.url)}
            alt={cover.alt || project.title}
            loading="lazy"
            className="h-full w-full object-cover grayscale-[35%] transition-all duration-700 ease-out group-hover:scale-105 group-hover:grayscale-0"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent opacity-80 transition-opacity duration-500 group-hover:opacity-95" />

        <div className="absolute left-4 top-4 flex flex-wrap gap-1.5">
          {(project.categories?.length ? project.categories : [project.category]).slice(0, 2).map((c) => (
            <span
              key={c}
              className="rounded-full border border-white/15 bg-black/40 px-3.5 py-1.5 text-[11px] font-medium uppercase tracking-[0.16em] text-white/90 backdrop-blur-xl"
            >
              {c}
            </span>
          ))}
          {(project.categories?.length || 0) > 2 && (
            <span className="rounded-full border border-white/15 bg-black/40 px-3 py-1.5 text-[11px] font-medium text-white/70 backdrop-blur-xl">
              +{project.categories.length - 2}
            </span>
          )}
        </div>
        <div className="absolute right-4 top-4 font-mono text-[11px] tracking-[0.2em] text-white/60">
          {project.year}
        </div>

        <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
          <h3 className="font-display translate-y-1 text-xl font-bold tracking-tight text-white transition-transform duration-500 group-hover:translate-y-0 md:text-2xl">
            {project.title}
          </h3>
          <p className="mt-1 max-w-md text-sm text-neutral-400 opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100 translate-y-2">
            {project.subtitle}
          </p>
        </div>
      </div>
    </Link>
  );
}
